import React, {MutableRefObject, useContext, useEffect, useRef} from 'react';
import {
    Alert,
    Button,
    Col,
    DatePicker,
    Form,
    Input,
    InputNumber,
    Modal,
    Row,
    Select,
    Space,
    Switch,
    Upload,
    UploadProps
} from 'antd';
import Colors from "../../../styles/Colors";
import {BiCheck, BiX} from "react-icons/bi";
import TextArea from "antd/es/input/TextArea";
import {CloseOutlined, InboxOutlined} from "@ant-design/icons";
import {AuthContext} from "../../../config/AuthContext";
import Activitat from "../../../model/multilleure/casals/Activitat";
import {PostActivitat} from "../../../dao/multilleure/PostActivitat";

interface IngredientModalProps {
    element: Activitat;
    visible: boolean;
    onClose: () => void;
    editar: boolean;
    ref1: MutableRefObject<null>;
    ref2: MutableRefObject<null>;
    ref3: MutableRefObject<null>;
    ref4: MutableRefObject<null>;
    ref5: MutableRefObject<null>;
    ref6: MutableRefObject<null>;
    ref7: MutableRefObject<null>;
    ref8: MutableRefObject<null>;
}

const ActivitatsModal: React.FC<IngredientModalProps> = ({element, visible, onClose, editar, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8}) => {
    const [form] = Form.useForm();
    const format = 'DD-MM-YYYY';

    const {isLoggedIn, userId, user, page} = useContext(AuthContext);


    useEffect(() => {

        console.log(JSON.stringify(element.files));
    }, []);

    async function handleSubmit() {
        const formData = form.getFieldsValue();
        console.log("Form Data:", formData);
        console.log(JSON.stringify(formData));
        await PostActivitat(page, formData);
        onClose();
    };

    const handleCancel = () => {
        onClose();
    };

    const estat = [
        {
            value: "pendent",
            label: "Pendent"
        },
        {
            value: "actiu",
            label: "Actiu"
        },
        {
            value: "inscripcions",
            label: "Actiu Inscripcions"
        },
        {
            value: "actiu secundari",
            label: "Actiu Secundari"
        },
        {
            value: "desactivat",
            label: "Desactivat"
        },
    ]
    const tipologies = [
        {
            value: "0",
            label: "Sense tipus"
        },
        {
            value: "casal",
            label: "Casal"
        },
        {
            value: "extraescolar",
            label: "Extraescolar"
        },
        {
            value: "menjador",
            label: "Menjador"
        },
    ]
    const emails = [
        {
            value: 0,
            label: "comandesambitescola@gmail.com"
        },
        {
            value: 1,
            label: "administracio@ambitescola.cat"
        },
        {
            value: 2,
            label: "administracio@artiesport.cat"
        },
    ]

    const apiUrl = process.env.REACT_APP_API_URL;
    const {Dragger} = Upload;
    const props: UploadProps = {
        name: 'files',
        method: 'POST',
        defaultFileList: element.files.fileList,
        multiple: true,
        showUploadList: {
            showDownloadIcon: true,
            downloadIcon: 'Download',
            showRemoveIcon: true
        },
        action: `${apiUrl}:8073/activitats/${element.id}/documents`,
        headers: {
            'pantalla': `${page}`
        },
        /*
        onDrop(e) {
            console.log('Dropped files', e.dataTransfer.files);
        },*/
    };

    return (
        <Modal
            title="ACTIVITAT"
            open={visible}
            onCancel={handleCancel}
            footer={[]}
            width={1000}
        >
            <Form form={form} initialValues={element} onFinish={handleSubmit} disabled={!editar}
                  encType="multipart/form-data">
                <hr/>
                <Row gutter={[16, 16]} ref={ref2}>
                    <Col span={12}>
                        <Form.Item label="ID" name="id">
                            <Input disabled/>
                        </Form.Item>
                        <Form.Item label="Nom" name="nom"
                                   rules={[{required: true, message: 'Aquest camp es obligatori'}]}>
                            <Input/>
                        </Form.Item>
                        <Form.Item label="Any" name="any"
                                   rules={[{required: true, message: 'Aquest camp es obligatori'}]}>
                            <DatePicker mode={"year"} format={'YYYY'}/>
                        </Form.Item>
                        <Form.Item label="Estat" name="estat"
                                   rules={[{required: true, message: 'Aquest camp es obligatori'}]}>
                            <Select showSearch
                                    placeholder="Selecciona Tipologia"
                                    optionFilterProp="children"
                                    options={estat}
                            />
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <Form.Item label="Tipologia" name="tipus"
                                   rules={[{required: true, message: 'Aquest camp es obligatori'}]}>
                            <Select showSearch
                                    placeholder="Selecciona Tipologia"
                                    optionFilterProp="children"
                                    options={tipologies}
                            />
                        </Form.Item>
                        <div ref={ref5}>
                        <Form.Item label="Data descompte anticipat (inclosa)" name="dataDescompte"
                                   rules={[{required: true, message: 'Aquest camp es obligatori'}]}>
                                <DatePicker mode={"date"}
                                            format={format}/>
                        </Form.Item>
                        </div>
                        <div ref={ref4}>
                        <Form.Item label="Email enviament" name="email"
                                   rules={[{required: true, message: 'Aquest camp es obligatori'}]}>
                            <Select showSearch
                                    placeholder="Selecciona email d'enviament"
                                    optionFilterProp="children"
                                    options={emails}
                            />
                        </Form.Item>
                        </div>
                        {/*
                        <Form.Item label="Descompte anticipat" name="descompteAnticipat"
                                   rules={[{required: true, message: 'Aquest camp es obligatori'}]}>
                            <InputNumber formatter={(value) => `${value}%`}/>
                        </Form.Item>
                        <Form.Item label="Descompte Germans" name="descompteGermans"
                                   rules={[{required: true, message: 'Aquest camp es obligatori'}]}>
                            <InputNumber formatter={(value) => `${value}%`}/>
                        </Form.Item>
                        <Form.Item label="Descompte Setmana" name="descompteSetmana"
                                   rules={[{required: true, message: 'Aquest camp es obligatori'}]}>
                            <InputNumber formatter={(value) => `${value}%`}/>
                        </Form.Item>*/}
                        <Form.Item label="Preu Rebut" name="preuRebut"
                                   rules={[{required: true, message: 'Aquest camp es obligatori'}]}>
                            <InputNumber ref={ref3} addonAfter="€"/>
                        </Form.Item>
                    </Col>
                </Row>
                <h6>Documentació requerida per la inscripció</h6>
                <hr/>
                <Alert type={"info"}
                       message={"Si es necesita adjuntar un document per aplicar un descompte, especifica els euros de descompte a la columna Descompte!"}/>
                <br/>
                <Row gutter={[16, 16]} ref={ref6}>
                    <Col span={24}>
                        <Form.List name="documents">
                            {(fields, {add, remove}) => (
                                <div style={{display: 'flex', flexDirection: 'column'}}>
                                    {fields.map((field) => (
                                        <Space>
                                            <CloseOutlined style={{marginBottom: 30}}  disabled={!editar}
                                                           onClick={() => remove(field.name)}/>
                                            <Form.Item label="Nom" name={[field.name, 'nom']}
                                                       rules={[{required: true, message: 'Aquest camp es obligatori'}]}>
                                                <Input/>
                                            </Form.Item>
                                            <Form.Item label="Descripció" name={[field.name, 'descripcio']}
                                                       rules={[{required: true, message: 'Aquest camp es obligatori'}]}>
                                                <TextArea/>
                                            </Form.Item>
                                            <Form.Item label="Descompte" name={[field.name, 'descompte']}>
                                                <InputNumber defaultValue={0.00} addonAfter="€"/>
                                            </Form.Item>
                                            <Form.Item label="Obligatori" name={[field.name, 'obligatori']}>
                                                <Switch/>
                                            </Form.Item>
                                        </Space>
                                    ))}

                                    <Button type="dashed" onClick={() => add()} block>
                                        + Afegir Document inscripció
                                    </Button>
                                    <br/>
                                    {element.id !== 0 && (
                                        <Alert type={"info"}
                                               message={"Si hi ha documents a descarregar per omplir i tornar a pujar s'han d'afegir al següent apartat!"}/>
                                    )}
                                    {element.id === 0 && (
                                        <>
                                            <Alert type={"warning"}
                                                   message={"Per pujar fitxers necessaris per formalitzar les inscripcions guarda primer l'activitat i torna-la a editar!!"}/>
                                            <br/>
                                        </>
                                    )}
                                </div>
                            )}
                        </Form.List>
                    </Col>
                </Row>
                {element.id !== 0 && (
                    <>
                        <br/>
                        <h6>Documents a omplir per formalitzar la inscripció:</h6>
                        <Row gutter={[16, 16]}>
                            <Col span={24}>
                                <Form.Item name="files">
                                    <Dragger  {...props}  disabled={!editar}>
                                        <p className="ant-upload-drag-icon">
                                            <InboxOutlined/>
                                        </p>
                                        <p className="ant-upload-text">Clica o arrossega els fitxers a aquesta zona</p>
                                        <p className="ant-upload-hint">Soport per a pujar un o diversos fitxers a
                                            l'hora.</p>
                                    </Dragger>
                                </Form.Item>
                                {/*<Table
                                    {...tableProps}
                                    onChange={onChangeTable}
                                    columns={columns}
                                    dataSource={coleccio}
                                />*/}
                            </Col>
                        </Row>
                    </>
                )}
                <h6>Emails</h6>
                <hr/>
                <Row gutter={[16, 16]} ref={ref7}>
                    <Col span={24}>
                        <Alert type={"warning"}
                               message={"IMPORTANT: Ha de contenir la paraula '#atr0#' que es on es posarà el preu."}/>
                        <Form.Item label="Text Email" name="textEmail"
                                   rules={[{required: true, message: 'Aquest camp es obligatori'}]}>
                            <TextArea defaultValue={"<br/>TOTAL: #atr0# &euro;  (Aquest preu no inclou les activitats que s'especifica que es cobrarán un cop realitzades)."}/>
                        </Form.Item>
                        <Form.Item label="Text Email Capçalera" name="textEmailCapcalera">
                            <TextArea defaultValue={"<b>RESUM:</b><br/>"} />
                        </Form.Item>
                    </Col>
                </Row>
                <Row gutter={[16, 16]}>
                    <Col span={1}>
                        <Form.Item wrapperCol={{offset: 0, span: 16}}>
                            <Button title={"Aceptar"} htmlType={"submit"}  ref={ref8}
                                    style={{backgroundColor: Colors.colors.color6}}><BiCheck/></Button>
                        </Form.Item>
                    </Col>
                    <Col span={1}>
                    </Col>
                    <Col span={1}>
                        <Button title={"Cancelar"} style={{backgroundColor: Colors.colors.color1}}
                                onClick={handleCancel}><BiX/></Button>
                    </Col>
                </Row>
            </Form>
        </Modal>
    );
};

export default ActivitatsModal;
